import { FC } from 'react';

import SandCoatingFormulationListing from 'components/main/SandCoatingFormulation';

const SandCoatingFormulation: FC = () => <SandCoatingFormulationListing />;

export default SandCoatingFormulation;
